var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1Gang({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8587 2.6665C20.5867 2.6665 19.5557 3.71106 19.5557 4.99984V42.9998C19.5557 44.2886 20.5867 45.3332 21.8587 45.3332H43.0304C44.3025 45.3332 45.3334 44.2886 45.3334 42.9998V4.99984C45.3334 3.71106 44.3025 2.6665 43.0304 2.6665H21.8587ZM43.7501 42.4452C43.7501 43.2993 43.3443 43.71 42.5026 43.71H22.3865C21.5441 43.71 21.139 43.2993 21.139 42.4452V5.55451C21.139 4.70118 21.5441 4.28969 22.3865 4.28969H42.5026C43.3443 4.28969 43.7501 4.70118 43.7501 5.55451V42.4452ZM27.7389 6.26071C27.3157 6.26071 26.9723 6.6243 26.9723 7.0723C26.9723 7.52111 27.3157 7.8839 27.7389 7.8839H37.148C37.5711 7.8839 37.9146 7.52111 37.9146 7.0723C37.9146 6.6243 37.5711 6.26071 37.148 6.26071H27.7389Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Gang);
export default __webpack_public_path__ + "static/media/1Gang.8c2b209d3d57b3ca9fc30870c0128f89.svg";
export { ForwardRef as ReactComponent };